import styled from "styled-components"

export default function ShippingAddressFormWrapper({ children }) {
  return <Wrapper>{children}</Wrapper>
}

const Wrapper = styled.div`
  position: relative;
  padding: 0 calc(100vw * (17 / 375));
  padding-bottom: calc(100vw * (17 / 375));
  height: 100%;
  overflow-y: scroll;
`
